import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MaterialTable from 'material-table';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  // Tooltip,
  ResponsiveContainer,
  Bar,
  BarChart,
  Label,
  // Cell,
} from 'recharts';

const styles = theme => ({
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
  tableContainer: {
    maxWidth: 1000,
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  paperGraph: {
    color: theme.palette.text.secondary,
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  entriesDataTitle: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesStartedValue: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  filteredEntriesValue: {
    color: '#FF8900',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesCompletedValue: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesDataSubValue: {
    color: '#000000',
    fontSize: 18,
    marginLeft: 15,
  },
});

class OnboardingGraph extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };

    this.columns = [
      {
        title: 'Create Acct Clicked',
        field: '0',
      },
      { title: 'Account Created', field: '1' },
      { title: 'Request SMS Code', field: '2' },
      { title: 'Resend Code Clicked', field: '3' },
      { title: 'SMS # Verified', field: '4' },
      { title: 'Completed Acct Setup', field: '5' },
      { title: 'Picked a Fave', field: '6' },
      { title: 'Completed Onboarding', field: '7' },
    ];
  }

  closeUserProfileDialog = event => {
    this.setState({
      userProfileDialog: false,
      userData: null,
    });
  };

  openUserProfileDialog = rowData => {
    this.setState({
      userProfileDialog: true,
      userData: rowData,
    });
  };
  render() {
    let { classes, tableData, onboardingProgressAnalytics } = this.props;

    return (
      <React.Fragment>
        <MaterialTable
          elevation={0}
          options={{
            pageSize: 2,
            toolbar: true,
            search: false,
            paging: true,
            exportButton: true,
          }}
          columns={this.columns}
          data={tableData}
          title="Progress"
        />

        <Paper className={classes.paper} elevation={1}>
          <Typography
            className={classes.subtitle}
            variant="subtitle1"
            gutterBottom
          >
            Progress graph
          </Typography>
          <ResponsiveContainer width="100%" height={250} id="chartResponsive">
            <BarChart
              data={onboardingProgressAnalytics}
              margin={{ top: 5, right: 30, left: 20, bottom: 35 }}
            >
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis dataKey="name" />
              <YAxis dataKey="clicks">
                <Label
                  value={'USERS'}
                  position="left"
                  angle={-90}
                  style={{ textAnchor: 'middle' }}
                />
              </YAxis>
              {/* <Tooltip content={<CustomTooltip classes={classes} />} /> */}
              <Bar dataKey="clicks" fill="#8884d8" maxBarSize={30}>
                {/* {data.map((entry, index) => {
                  return (
                    <Cell
                      // fill={gradient[Math.floor(entry.engagement) - 1]}
                      key={`cell-${index}`}
                    />
                  );
                })} */}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(OnboardingGraph);
